import { useEffect, useState } from "react";
import { MdCheckCircleOutline, MdDelete, MdOutlineCancel } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomerService from "../../rest/customerService";
import Lottie from 'react-lottie';
import completedAnimation from '../../resources/completed_animation2.json'
import TopNavBar from "../../components/reusables/topNavBar";
import { ajustedDate, getToday } from "../../utils/DateUtils";
import FinancialService from "../../rest/financialService";
import { AiOutlineClose } from "react-icons/ai";
import { formatCurrency } from "../../utils/CurrencyUtils";
import qs from 'qs';
import { useAuth } from "../../auth/AuthenticationWrapper";
import CustomButton from "../../components/lib/customButton";
import OrderService from "../../rest/orderService";
import { formatString } from "../../utils/StringUtils";
import { HistoryList } from "../../components/HistoryList";
import OrderInfo from "../../components/orderInfo";
import ClientService from "../../rest/clientService";
import PaymentSelect from "../../components/reusables/paymentSelect";

function EmployeePage() {
    const [loading, setLoading] = useState(false);

    const { searchInput } = useParams();
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalCredit, setShowModalCredit] = useState(false);
    const [showModalExpense, setShowModalExpense] = useState(false);
    const [orders, setOrders] = useState([]);
    const [order, setOrder] = useState(null);
    const [showOrderInfo, setShowOrderInfo] = useState(false);
    const [client, setClient] = useState(null);
    const [showAnimation, setShowAnimation] = useState(false);
    const [clientInfo, setClientInfo] = useState();
    const operator = sessionStorage.getItem('name');
    const { hasPermission } = useAuth();
    const canUpdate = hasPermission("customers", "update");
    const canUpdateCredits = hasPermission("customers", "update_credits");
    const canAddExpenses = hasPermission("customers", "add_expense");
    const canDelete = hasPermission("customers", "delete");
    const navigate = useNavigate();
    const [isOpened, setIsOpened] = useState(false)
    const [preferences, setPreferences] = useState();
    const [enabledPayments, setEnabledPayments] = useState();

    useEffect(() => {
        const info = JSON.parse(sessionStorage.getItem('clientInfo'));
        setClientInfo(info);

        const fetchData = async () => {
            try {
                const clientData = await CustomerService.getSpecificEmployee(searchInput);
                setClient(clientData);
                setEditedCredit(clientData.credit);
            } catch (error) {
                console.error(error);
            }
        };

        if (client && client.login) {
            const fetchClientDetails = async () => {
                const searchInput = getToday();
                const open = await FinancialService.checkIfOpen(searchInput);

                if (open === true) {
                    setIsOpened(true)
                }
                try {
                    const [orderResult, rechargeResult, expensesResult] = await Promise.allSettled([
                        OrderService.getAllOrdersFromClient(client.login),
                        OrderService.getAllCreditRechargesFromClient(client.login),
                        OrderService.getAllExpensesForClient(client.login),
                    ]);

                    const safeOrders =
                        orderResult.status === "fulfilled" && Array.isArray(orderResult.value)
                            ? orderResult.value
                            : [];

                    const safeRecharges =
                        rechargeResult.status === "fulfilled" && Array.isArray(rechargeResult.value)
                            ? rechargeResult.value
                            : [];

                    const safeExpenses =
                        expensesResult.status === "fulfilled" && Array.isArray(expensesResult.value)
                            ? expensesResult.value
                            : [];

                    const combinedOrders = [...safeOrders, ...safeRecharges, ...safeExpenses];
                    setOrders(combinedOrders);
                } catch (error) {
                    console.error(error);
                }
            };

            fetchClientDetails();
        }

        const getPreferences = async () => {
            const data = await ClientService.getClientAdminPreferences();
            setPreferences(data);
        }

        getPreferences();
        fetchData();
    }, [searchInput, client]);

    useEffect(() => {
        if (!preferences) {
            setEnabledPayments([]);
            return;
        }

        const enabled = preferences.accepted_payments
            ?.split(";")
            .map(v => v.trim().toUpperCase())
            .filter(Boolean) || [];

        setEnabledPayments(enabled);
    }, [preferences]);

    useEffect(() => {
        if (client) {
            setInitialCredit(client.credit);
        }
    }, [client]);

    const [creditCharge, setCreditCharge] = useState({
        paymentMethod: '',
        value: client ? client.credit : 0,
        received_value: 0.00,
        client_code: sessionStorage.getItem('clientCode'),
        customer_id: client ? client.login : '',
        transactionDate: ajustedDate(),
        transaction_type: 'Credit Recharge Admin'
    });

    const [editedCredit, setEditedCredit] = useState(0.00);
    const [receivedValue, setReceivedValue] = useState(0.00);
    const [selectedPayment, setSelectedPayment] = useState('');
    const [initialCredit, setInitialCredit] = useState(0);
    const [expenseMotive] = useState('');

    const handleSaveClick = async () => {
        const newValue = (Number(initialCredit) + Number(editedCredit || 0));

        if (initialCredit === newValue) {
            alert("Por favor, informe o valor a ser carregado.");
            return;
        }

        if (!selectedPayment || selectedPayment === "") {
            alert("Por favor, selecione uma forma de pagamento.");
            return;
        }

        setLoading(true);
        const updatedCreditCharge = {
            paymentMethod: selectedPayment,
            value: parseFloat(editedCredit),
            received_value: parseFloat(receivedValue),
            client_code: creditCharge.client_code,
            customer_id: client.login,
            transactionDate: creditCharge.transactionDate,
            transaction_type: creditCharge.transaction_type,
            transactionSource: "MANUAL"
        };

        setCreditCharge(updatedCreditCharge);

        try {
            await CustomerService.updateclientCredit(
                client.login,
                {
                    login: client.login,
                    credit: newValue.toFixed(2),
                    clientCode: client.clientCode
                },
                updatedCreditCharge
            );
            openReceipt(updatedCreditCharge);
            setShowAnimation(true);
            setTimeout(() => navigate(0), 1000);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveExpense = () => {
        const newValue = (Number(initialCredit) - Number(editedCredit || 0));

        if (initialCredit === newValue) {
            alert("Por favor, informe o valor a ser removido.");
            return;
        }

        setLoading(true);
        const updatedCreditCharge = {
            paymentMethod: selectedPayment,
            value: parseFloat(editedCredit),
            received_value: parseFloat(editedCredit),
            credit_afterwards: newValue,
            client_code: creditCharge.client_code,
            customer_id: client.login,
            transactionDate: creditCharge.transactionDate,
            transaction_type: 'Credit Expense',
            observations: expenseMotive,
            transactionSource: "MANUAL"
        };

        setCreditCharge(updatedCreditCharge);

        CustomerService.updateEmployeeCredit(
            client.login,
            {
                login: client.login,
                credit: newValue.toFixed(2),
                clientCode: client.clientCode
            },
            updatedCreditCharge
        )
            .then(() => {
                setShowAnimation(true);
                setTimeout(() => navigate(0), 1000);
            })
            .catch(error => console.error(error));
    };

    const renderOrderItem = (order) => (
        <>
            <p className={`font-medium ${order.status === 'CANCELED' ? 'text-custom_red line-through' : ''}`}>
                {order.items_list
                    ? formatString(order.items_list)
                    : order.transaction_type === 'Credit Recharge Admin' ? "RECARGA CRÉDITO" : "CORREÇÃO"}
            </p>

            {order.order_id != null && (
                <p className={`font-medium ${order.status === 'CANCELED' ? 'text-custom_red line-through' : ''}`}   >
                    Total: {order.total ? formatCurrency(order.total) : formatCurrency(order.value)}
                </p>
            )}
            {order.transaction_type === 'Credit Recharge Admin' ?
                <p className={`font-medium ${order.status === 'CANCELED' ? 'text-custom_red line-through' : ''}`}   >
                    Total Creditado: {order.total ? formatCurrency(order.total) : formatCurrency(order.value)}
                </p> :
                order.transaction_type === 'Credit Expense' ?
                    <p className={`font-medium ${order.status === 'CANCELED' ? 'text-custom_red line-through' : ''}`}   >
                        Total Descontado: {order.total ? formatCurrency(order.total) : formatCurrency(order.value)}
                    </p> : <></>
            }
        </>
    );

    const handleCancelClick = () => {
        setEditedCredit(client.credit);
        setShowModalCredit(false);
        setShowModalExpense(false)
    };

    const handleEditedCreditChange = (event) => {
        setEditedCredit(event.target.value);
    };

    const handlePaymentSelection = (value) => {
        setSelectedPayment(value);
    };

    const handleReceivedValue = (event) => {
        setReceivedValue(event.target.value);
    };


    const handleExpenseMotive = (value) => {
        setSelectedPayment(value);
    };

    const handleOrderClick = (selectedOrder) => {
        setOrder(selectedOrder);
        setShowOrderInfo(true);
    };

    const handleDelete = async () => {
        try {
            await CustomerService.deleteEmployee(client.login);
            setTimeout(() => navigate('/clientes'), 1000);
        } catch (error) {
            console.error(error);
        }
    };

    const modalDelete = () => setShowModalDelete(prev => !prev);
    const modalCredit = () => setShowModalCredit(prev => !prev);
    const modalExpense = () => { setShowModalExpense(!showModalExpense); }

    function openReceipt(updatedCreditCharge) {
        const win = window.open('', '_blank', 'toolbar=no,location=no,width=340,height=600');

        const queryString = qs.stringify({
            customer: JSON.stringify(client.name),
            currentCredit: JSON.stringify(client.credit),
            transactions: updatedCreditCharge,
            totalAmount: updatedCreditCharge.value,
            operator,
            clientInfo: JSON.stringify(clientInfo)
        });

        if (win) {
            win.location.href = `/comprovanteRecarga?${queryString}`;
        } else {
            alert("Não foi possível abrir a janela. Verifique se o popup está bloqueado.");
        }
    }

    return (
        <>
            {client ? (
                <div className='h-full flex flex-col'>
                    <TopNavBar />
                    <div className='mx-2 sm:mx-10 my-4 w-7/8 h-5/6'>
                        <div className="py-10">
                            <div className="grid grid-cols-2 gap-x-2">
                                <div className="py-2">
                                    <p className="flex break-all text-sm text-custom_gray_font font-semibold">Nome</p>
                                    <p className="w-full sm:px-3 py-1.5 text-sm font-medium text-custom_gray_font border border-solid border-gray-300 rounded"> {client.name === null || '' ? 'Não Registrado' : client.name}</p>
                                </div>
                                <div className="py-2">
                                    <p className="flex text-sm text-custom_gray_font font-semibold"> Login </p>
                                    <p className="flex w-full px-3 py-1.5 text-sm font-medium text-custom_gray_font border border-solid border-gray-300 rounded"> {client.login === null || '' ? 'Não Registrado' : client.login}</p>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-x-2">
                                <div className="py-2">
                                    <p className="flex text-sm text-custom_gray_font font-semibold"> Email</p>
                                    <p className="flex w-full px-3 py-2 break-all text-sm font-medium break-words text-custom_gray_font border border-solid border-gray-300 rounded"> {client.email === null || '' ? 'Não Registrado' : client.email}</p>
                                </div>
                                <div className="py-2">
                                    <p className="flex text-sm text-custom_gray_font font-semibold">Telefone</p>
                                    <p className="flex w-full px-3 py-1.5 text-sm font-medium text-custom_gray_font border border-solid border-gray-300 rounded"> {client.phone_number === null || client.phone_number === '' ? 'Não Registrado' : client.phone_number}</p>
                                </div>
                            </div>
                            <div>
                                <p className="flex mt-4 text-sm text-custom_gray_font font-semibold">Saldo</p>
                                <div className="flex items-center">
                                    <p className="flex w-full mr-4 px-3 py-1.5 text-sm font-medium text-custom_gray_font border border-solid border-gray-300 rounded">
                                        {formatCurrency(client.credit)}
                                    </p>
                                    <CustomButton buttonType={"editCredits"} type={'button'} disabled={!canUpdateCredits} showIcon={true} onClick={modalCredit} />
                                    <CustomButton className={'text-sm w-3/4 mx-2'} buttonType={"cancel"} type={'button'} disabled={!canAddExpenses} showIcon={false} text={'Correção'} onClick={modalExpense} />
                                </div>
                            </div>
                            <div className="grid grid-cols-3 gap-x-2">
                                <div className="py-2">
                                    <p className="flex mt-4 pt-2 text-sm text-custom_gray_font font-semibold">Valor de
                                        Emergência disponível</p>
                                    <p className="flex w-full px-3 py-1.5 text-sm font-medium text-custom_gray_font border border-solid border-gray-300 rounded"> {client.credit <= 0 ? formatCurrency(client.emergency_value + client.credit) : formatCurrency(client.emergency_value)}</p>
                                </div>

                                <div className="py-2">
                                    <p className="flex mt-4 pt-2 text-sm text-custom_gray_font font-semibold">Limite de
                                        Emergência</p>
                                    <p className="flex w-full px-3 py-1.5 text-sm font-medium text-custom_gray_font border border-solid border-gray-300 rounded"> {formatCurrency(client.emergency_value)}</p>
                                </div>

                                <div className="py-2">
                                    <p className="flex mt-4 pt-2 text-sm text-custom_gray_font font-semibold">Limite de
                                        gastos
                                        diários</p>
                                    <p className="flex w-full px-3 py-1.5 text-sm font-medium text-custom_gray_font border border-solid border-gray-300 rounded"> {formatCurrency(client.spend_limit)}</p>
                                </div>
                            </div>
                            <div>
                                <HistoryList
                                    title="Histórico de Pedidos"
                                    data={orders}
                                    renderItem={renderOrderItem}
                                    onItemClick={handleOrderClick}
                                />
                                {order && (
                                    <OrderInfo
                                        order={order}
                                        showOrderInfoModal={showOrderInfo}
                                        handleCancelClick={() => setShowOrderInfo(false)}
                                        customer={client}
                                    />
                                )}
                            </div>
                            <div className="grid grid-cols-2 gap-x-2 py-4">
                                <CustomButton className={'w-full mx-2'} buttonType={"edit"} type={"button"} text={"Editar"} showIcon={true} disabled={!canUpdate} onClick={() => navigate(`/clientes/editarColaborador/${client.login}`)} />
                                <CustomButton className={'px-6'} buttonType={"delete"} type={"button"} text={"Excluir"} showIcon={true} disabled={!canDelete} onClick={modalDelete} />
                            </div>
                        </div>

                        {/* Modal Delete */}
                        <div
                            className={`flex items-center justify-end top-0 right-0 bg-black/50
                            p-24 py-14 text-custom_gray_font fixed w-full h-full z-60 ${showModalDelete ? "translate-x-0 shadow-xl " : "translate-x-full"}`}
                        >
                            <div className="rounded-lg bg-white w-full z-70 p-6 lg:p-12 shadow-lg">
                                <p className="md:p-4 text-xs md:text-base lg:text-2xl">Tem certeza que deseja remover o cadastro de colaborador do sistema?</p>
                                <div className="text-xs lg:text-base lg:flex">
                                    <button className='flex items-center justify-center bg-custom_blue w-full h-10 text-white font-medium p-2 m-2 rounded-lg' onClick={handleDelete}>
                                        <MdDelete className="text-white scale-150 mx-2" />
                                        <p className=" text-white font-medium leading-tight">Excluir</p>
                                    </button>
                                    <button className='flex items-center justify-center bg-custom_red w-full h-10 text-white font-medium p-2 m-2 rounded-lg' onClick={modalDelete}>
                                        <MdOutlineCancel className="text-white scale-150 mx-2" />
                                        <p className="text-white font-medium leading-tight"> Cancelar</p>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Modal Recarga Credito */}
                        <div
                            className={`flex items-center justify-end top-0 right-0 bg-black/50 p-20 py-6 text-custom_gray_font fixed w-full h-full z-60 ${showModalCredit ? "translate-x-0 shadow-xl " : "translate-x-full"}`}>
                            <div className="rounded-lg bg-white w-full h-2/3 z-70 p-4 shadow-lg">
                                {showAnimation ? (
                                    <Lottie
                                        options={{
                                            animationData: completedAnimation,
                                        }}
                                        height={'60%'}
                                        width={'60%'}
                                        style={{
                                            height: '60%',
                                            width: '60%'
                                        }}
                                    />
                                ) : (
                                    <>
                                        {isOpened ?
                                            <>
                                                <p className="p-2 my-2 text-xl xl:text-3xl text-center">Recarga de Crédito</p>
                                                <div className="flex flex-col xl:p-10">
                                                    <div className="items-center justify-center">
                                                        <p className="xl:text-xl">Valor
                                                            atual: {formatCurrency(client.credit)} </p>
                                                        <div className="flex items-center justify-between">
                                                            <p className="xl:text-xl">Valor a ser carregado: </p>
                                                            <input
                                                                type="number"
                                                                className="w-1/3 p-2 text-base font-medium text-custom_gray_font border-b border-solid border-slate-300 rounded"
                                                                step="0.05"
                                                                min="0.01"
                                                                onChange={handleEditedCreditChange}
                                                            />
                                                        </div>
                                                        <div className="flex items-center justify-between">
                                                            <p className="xl:text-xl">Valor recebido: </p>
                                                            <input
                                                                type="number"
                                                                className="w-1/3 p-2 text-base font-medium text-custom_gray_font border-b border-solid border-slate-300 rounded"
                                                                step="0.05"
                                                                min="0.01"
                                                                onChange={handleReceivedValue}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col lg:flex-row  items-center justify-between mt-2">
                                                        <p className="mr-4">Forma de Pagamento:</p>
                                                        <PaymentSelect
                                                            enabledValues={enabledPayments}
                                                            value={selectedPayment}
                                                            onChange={setSelectedPayment}
                                                        />
                                                    </div>
                                                    <div className="flex items-center justify-center mt-4">
                                                        <>
                                                            <button
                                                                className="flex items-center justify-center space-x-2 px-10 py-2.5 m-2 bg-custom_green w-full h-full rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-700  active:shadow-lg transition duration-150 ease-in-out disabled:opacity-50"
                                                                onClick={handleSaveClick}
                                                                disabled={loading}
                                                            >
                                                                <MdCheckCircleOutline
                                                                    className="text-white scale-150 mx-2" />
                                                                <p className=" text-white font-medium leading-tight"> Salvar </p>
                                                            </button>
                                                        </>

                                                        <button
                                                            className="flex items-center justify-center space-x-2 px-10 py-2.5 m-2 bg-custom_red w-full h-full rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-700  active:shadow-lg transition duration-150 ease-in-out disabled:opacity-50"
                                                            onClick={handleCancelClick}
                                                            disabled={loading}
                                                        >
                                                            <MdOutlineCancel className="text-white scale-150 mx-2" />
                                                            <p className=" text-white font-medium leading-tight"> Cancelar</p>
                                                        </button>
                                                    </div>
                                                </div>
                                            </> :
                                            <div
                                                className="w-full flex flex-col items-center justify-center text-xl font-medium p-6 relative">
                                                <button
                                                    className="flex text-4xl text-custom_gray_font items-center cursor-pointer absolute top-4 right-4 z-80"
                                                    onClick={() => (setShowModalCredit(false))}>
                                                    <AiOutlineClose />
                                                </button>
                                                <p className="text-6xl font-bold my-4">Caixa Fechado</p>
                                                <p>Para realizar recargas por favor realize a abertura de caixa.</p>
                                                <Link to={`/financeiro`} target="_self">
                                                    <button
                                                        type='button'
                                                        className='bg-custom_blue text-white p-4 rounded-lg font-semibold disabled:opacity-50 my-10'
                                                    >
                                                        Abrir Caixa
                                                    </button>
                                                </Link>
                                            </div>
                                        }
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Modal Despesas */}
                        <div
                            className={`flex items-center justify-end top-0 right-0 bg-black/50 p-20 py-6 text-custom_gray_font fixed w-full h-full z-60 ${showModalExpense ? "translate-x-0 shadow-xl " : "translate-x-full"}`}>
                            <div className="rounded-lg bg-white w-full h-2/3 z-70 p-4 shadow-lg">
                                {showAnimation ? (
                                    <Lottie
                                        options={{
                                            animationData: completedAnimation,
                                        }}
                                        height={'60%'}
                                        width={'60%'}
                                        style={{
                                            height: '60%',
                                            width: '60%'
                                        }}
                                    />
                                ) : (
                                    <>
                                        <p className="p-2 my-2 text-xl xl:text-3xl text-center">Lançamento de Correção de Crédito</p>
                                        <div className="flex flex-col xl:p-10">
                                            <div className="items-center justify-center">
                                                <p className="xl:text-xl">Valor
                                                    atual: {formatCurrency(client.credit)} </p>
                                                <div className="flex items-center justify-between">
                                                    <p className="xl:text-xl">Valor a ser removido: </p>
                                                    <input
                                                        type="number"
                                                        className="w-1/3 p-2 text-base font-medium text-custom_gray_font border-b border-solid border-slate-300 rounded"
                                                        step="0.05"
                                                        min="0.01"
                                                        onChange={handleEditedCreditChange}
                                                    />
                                                </div>
                                                <div className="flex items-center justify-between mt-4">
                                                    <p className="xl:text-xl">Motivo: </p>
                                                    <select
                                                        className="block w-full lg:w-2/3 p-2 rounded-md text-sm bg-white shadow-md border-2 border-slate-200 focus:border-indigo-500 focus:ring focus:ring-indigo-200"
                                                        onChange={(e) => handleExpenseMotive(e.target.value)}
                                                        value={selectedPayment}
                                                        required
                                                    >
                                                        <option value="">Selecione uma opção...</option>
                                                        <option value="Recarga feita incorretamente.">Recarga feita incorretamente.</option>
                                                        <option value="Outro.">Outro...</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="flex items-center justify-center mt-4">
                                                <>
                                                    <button
                                                        className="flex items-center justify-center space-x-2 px-10 py-2.5 m-2 bg-custom_green w-full h-full rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-700  active:shadow-lg transition duration-150 ease-in-out disabled:opacity-50"
                                                        onClick={handleSaveExpense}
                                                        disabled={loading}
                                                    >
                                                        <MdCheckCircleOutline
                                                            className="text-white scale-150 mx-2" />
                                                        <p className=" text-white font-medium leading-tight"> Salvar </p>
                                                    </button>
                                                </>

                                                <button
                                                    className="flex items-center justify-center space-x-2 px-10 py-2.5 m-2 bg-custom_red w-full h-full rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-700  active:shadow-lg transition duration-150 ease-in-out disabled:opacity-50"
                                                    onClick={handleCancelClick}
                                                    disabled={loading}
                                                >
                                                    <MdOutlineCancel className="text-white scale-150 mx-2" />
                                                    <p className=" text-white font-medium leading-tight"> Cancelar</p>
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (<> <p>Nenhum cadastro encontrado.</p></>)
            }
        </>
    );
}

export default EmployeePage;